const projects = [
    {
        title: "KRM autos en services - Car Repair Shop Website",
        description: "A custom-built website for KRM autos en services, a local car repair shop. This platform provides essential business information, services, and contact details in a user-friendly interface. The website is designed to enhance the online presence of KRM autos en services and attract potential customers. Currently, this is a demo version.",
        image: "/assets/img/KRM.png",
        tags: ["Web Development", "React"],
        category: "web",
        github: null,
        demo: "https://krmautosenservice.nl/",
        featured: true
    }, 
    {
        title: "SkyVoyage - Airline Information System",
        description: "A comprehensive airline information system developed for a school project, featuring a user-friendly interface for managing flight schedules, bookings, and customer information. The system is designed to streamline airline operations and enhance customer experience. It makes use of API'S to fetch real-time flight data.",
        image: "/assets/img/SkyVoyage.png",
        tags: ["JAVA", "School Project", "Responsive Design"],
        category: "JAVA",
        github: null,
        demo: null,
        featured: false
    },
    {
        title: "Harman Abbasi - Portfolio Website",
        description: "A portfolio website designed for Harman Abbasi, showcasing his work and projects. The site features a modern design, responsive layout, and easy navigation to highlight his skills and achievements.",
        image: "/assets/img/HarmanPortfolio.png",
        tags: ["Web Development", "Portfolio", "Responsive Design"],
        category: "web",
        github: null,
        demo: "https://harmanabbasi.nl/",
        featured: false
    },
    {
        title: "Appcomm Python Logger",
        description: "A robust logging solution developed during my internship at Appcomm. This Python package supports logging to multiple destinations: terminal with colorized output, files, various databases (MySQL, PostgreSQL, SQLite, etc.), Elasticsearch, and FTP servers. It features custom log levels, detailed exception handling, and configurable settings, making it ideal for comprehensive application monitoring and debugging.",
        image: "/assets/img/pypi.png",
        tags: ["Python", "Logging", "Database Integration", "Elasticsearch", "FTP"],
        category: "tool",
        github: null,
        demo: "https://pypi.org/project/Appcomm-python-Logger",
        featured: false
    },
    {
        title: "Audiometer - Hearing Assessment Tool",
        description: "A client-focused tool designed to evaluate individuals' hearing capabilities by playing beep sounds at various frequencies and volumes. Primarily aimed at children, the Audiometer provides an intuitive interface for hearing assessments. The results are displayed in a detailed graph, enabling the client to create personalized music that enhances auditory development.",
        image: "/assets/img/audiometer.png",
        tags: ["Hearing Assessment", "Android Development", "Data Visualization"],
        category: "android",
        github: null,
        demo: null,
        featured: true
    }, 
    // {
    //     title: "Slijpen Auto's - Car Repair Shop Website",
    //     description: "A custom-built website for Slijpen Auto's, a local car repair shop. This platform provides essential business information, services, and contact details in a user-friendly interface. Currently, this is a demo version, with the official version set to be deployed on their domain soon.",
    //     image: "/assets/img/slijpen3.jpeg",
    //     tags: ["Web Development", "PHP", "JavaScript", "SQLite"],
    //     category: "web",
    //     github: null,
    //     demo: "https://slijpenautos.furkanozturk.nl/",
    //     featured: false
    // }, 
    {
        title: "Red & Blue HackingTool",
        description: "A security assessment tool designed to test websites against common vulnerabilities by executing safe penetration tests. The tool generates a detailed report, highlighting potential security risks and providing insights into website safety. Developed entirely in Python, it follows the OWASP Top 10 framework to simulate various security threats.",
        image: "/assets/img/RedAndBlueHome.png",
        tags: ["Cybersecurity", "Penetration Testing", "Python", "OWASP Top 10"],
        category: "security",
        github: "#",
        demo: "https://redandblue.furkanozturk.nl/",
        featured: true
    },
    {
        title: "SDG Scan Tool",
        description: "A sustainability assessment tool developed during an internship at IBI² - Institute for Sustainable Transitions & Biomimicry Innovations. The tool helps companies evaluate their performance on the Sustainable Development Goals (SDGs) and generates detailed reports with improvement recommendations based on EU standards. Users can create, review, and print reports while tracking progress over time. This project provided hands-on experience in full-stack development, including authentication, database management, and report generation.",
        image: "/assets/img/scantool.png",
        tags: ["Sustainability", "SDGs", "Full Stack Development", "PHP"],
        category: "web",
        github: null,
        demo: "https://sdg-scantool.ibi2.nl/index.php",
        featured: false
    }, 
    {
        title: "Bruto naar Netto",
        description: "A simple and efficient tool designed to calculate your net hourly wage based on your gross earnings and hours worked. Ideal for freelancers, flexible-hour employees, or anyone curious about their net income, this tool streamlines the process. Users can input their gross hourly wage and hours worked, then click 'Calculate' to instantly discover their estimated net hourly wage.",
        image: "/assets/img/brutonetto.webp",
        tags: ["Finance", "Web Development", "Calculator"],
        category: "web",
        github: "#",
        demo: "https://brutonetto.furkanozturk.nl/",
        featured: false
    },
    {
        title: "Hall of Haydo",
        description: "This is a site I made for myself, my brother, cousin, and anyone else who is interested in watching Kufurbaz Haydo quickly and easily. We experienced difficulty in finding high-quality videos of the series, so I thought, why not make it a lot easier for us?",
        image: "/assets/img/haydoTumbnail.jpg",
        tags: ["Entertainment", "Web Development", "Video Streaming"],
        category: "web",
        github: null,
        demo: "https://hallofhaydo.furkanozturk.nl/",
        featured: true
    },
];

export default projects;